import { render, staticRenderFns } from "./installPartition.vue?vue&type=template&id=f83f93de&scoped=true&"
import script from "./installPartition.vue?vue&type=script&lang=js&"
export * from "./installPartition.vue?vue&type=script&lang=js&"
import style0 from "./installPartition.vue?vue&type=style&index=0&id=f83f93de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83f93de",
  null
  
)

export default component.exports